import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PanHandModeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PanHandMode",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M22.42 16.86c-.63 0-1.14-.51-1.14-1.14V4.86a1.71 1.71 0 1 0-3.42 0v10.86a1.14 1.14 0 1 1-2.28 0V4.86c0-2.21 1.79-4 4-4s4 1.79 4 4v10.86c0 .63-.51 1.14-1.14 1.14Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.42 31.71h-7.91c-1.53 0-2.96-.6-4.04-1.67L2.03 21.6a4.01 4.01 0 0 1 0-5.66 4.01 4.01 0 0 1 5.66 0l5.82 5.82c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-5.82-5.82c-.67-.67-1.76-.67-2.42 0-.67.67-.67 1.76 0 2.42l8.44 8.44c.65.65 1.51 1 2.42 1h7.91c1.89 0 3.43-1.54 3.43-3.43v-.11l.73-7.27c.24-2.34.81-5.2 1.74-8.72.25-.92-.3-1.86-1.21-2.1-.91-.25-1.85.3-2.1 1.21l-1.48 6.94a1.144 1.144 0 1 1-2.24-.48l1.49-7a4.02 4.02 0 0 1 4.91-2.89c2.13.57 3.4 2.77 2.83 4.9-.91 3.4-1.45 6.13-1.68 8.35l-.72 7.21a5.715 5.715 0 0 1-5.71 5.65Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.7 23.71c-.5 0-.97-.34-1.1-.85L7.81 8.74c-.57-2.13.7-4.33 2.83-4.9s4.33.7 4.9 2.83l2.28 8.75c.16.61-.21 1.24-.82 1.39a1.14 1.14 0 0 1-1.39-.82l-2.28-8.74a1.71 1.71 0 0 0-2.1-1.2c-.91.24-1.46 1.19-1.21 2.1l3.79 14.12a1.145 1.145 0 0 1-1.11 1.44"
    })]
  }));
};